<template>
	<div class="c-process-steps" v-scroll-spy="{allowNoActive: true, offset: 300}">
		<template v-for="(step, index) in processSteps">
			<process-step 
				v-bind="step" 
				:process-id="processId" 
				:index="index" 
				:process-type="processType"
				@deleteProcessStep="deleteProcessStep" 
				@editProcessStep="editProcessStep"
				@sortProcessStep="sortProcessStep"
				:sortIndexes="processSteps.map(step => step.sortIndex).sort()"
				@publish="publishStep"
				@unpublish="unpublishStep">
			</process-step>
		</template>
		<can i="manage" :a="processType">
			<button v-if="!showCreate && processId !== '0'" class="c-button c-button--primary t-margin-top-s" @click="toggleShowCreate">Lägg till processteg</button>
			<process-step 
				mode="create" 
				v-if="showCreate" 
				:process-id="processId" 
				:process-type="processType"
				@createProcessStep="createProcessStep" 
				@toggleShowCreate="toggleShowCreate">
			</process-step>
		</can>
	</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import ProcessStep from './../process-step/ProcessStep.vue';
export default {
    name: 'ProcessSteps',
	components: {ProcessStep},
    props: {
        processId: {
            type: String,
            default: '0'
		},
		processSteps: {
			type: Array,
			default: () => []
		},
		showCreate: {
			type: Boolean,
			default: false
		},
		processType: {
			type: String,
			default: ''
		},
	},
	methods: {
		toggleShowCreate() {
			this.$emit('setShowCreate', !this.showCreate);
		},
		createProcessStep({processId, name, description}) {
			this.$emit('createProcessStep', {processId, name, description});
		},
		deleteProcessStep(processStepId) {
			this.$emit('deleteProcessStep', processStepId);
		},
		editProcessStep({id, name, description}) {
			this.$emit('editProcessStep', {id, name, description});
		},
		sortProcessStep({ id, sortIndex }) {
			this.$emit('sortProcessStep', { id, sortIndex });
		},
		publishStep({id}) {
			this.$emit('publish', {id: id});
		},
		unpublishStep({id}) {
			this.$emit('unpublish', {id: id});	
		}
	},
}
</script>
